import { Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import React, { Fragment, useRef, useState, useEffect } from "react";
import { getToken, getUserDetail } from "../../../../../middleware/storage";
import { connect, useSelector } from "react-redux";
import { setAddressDetails, resetBilling } from "../bpSlice";
import PhoneNumber from "./masked_phone_number";
import SelectCountry from "./select_country";
import SelectState from "./select_state";

const useStyles = makeStyles((theme) => ({
  root: { marginBottom: theme.spacing(2) },
  formControl: {
    marginBottom: theme.spacing(2),
  },
}));

const blankAddressDetails = {
  line1: "",
  line2: "",
  postalCode: "",
  state: "",
  city: ""
}

const cleanAddress = {
  firstName: "",
  lastName: "",
  line1: "",
  line2: "",
  city: "",
  state: "",
  postalCode: "",
  countryCode: "",
  emailAddress: "",
  phoneNumber: "1868"
}

function hasKey(obj, key) {
  return key in obj;
}
function AddressForm(props) {
  const classes = useStyles();
  const ref = useRef(null);
  let states = [];

  const { setAddressDetails, addressDetailsState, errors, resetBilling } = props;
  const { countries, cCards } = useSelector((state) => state.billpay);
  const { customerCardId } = useSelector((state) => state.billpay.paymentDetails);
  const [addressDetails, updateAddressDetails] = useState(addressDetailsState);
  const token = getToken();
  
  useEffect(() => {
	  if (token && addressDetailsState.emailAddress == "") 
    {
      if(customerCardId != 0)
      {
        if (hasKey(cCards[0], "customerCardId")) {
          for (var i = 0; i < cCards.length; i++) {
            if (cCards[i].customerCardId === customerCardId)
            {
              if(cCards[i].billingAddress.id != 0)
              {
                const updatedAddressDetails = {
                  ...addressDetails,
                  ...cCards[i].billingAddress,
                };
                
                setAddressDetails(updatedAddressDetails);
                updateAddressDetails(updatedAddressDetails);
                break;
              }
              else
              {
                setAddressDetails(cleanAddress);
                updateAddressDetails(cleanAddress);
                break;                
              }
            }
          }
        }
      }
    }
    else if (token) 
    {
      if(customerCardId != 0)
      {
        if (hasKey(cCards[0], "customerCardId")) {
          for (var i = 0; i < cCards.length; i++) {
            if (cCards[i].customerCardId === customerCardId)
            {
              if(cCards[i].billingAddress.id != 0)
              {
                const updatedAddressDetails = {
                  ...addressDetails,
                  ...cCards[i].billingAddress,
                };
                
                setAddressDetails(updatedAddressDetails);
                updateAddressDetails(updatedAddressDetails);
                break;
              }
              else
              {
                setAddressDetails(cleanAddress);
                updateAddressDetails(cleanAddress);
                break;                
              }
            }
          }
        }
      }
    }
 
  }, []);

  const handleChange = (prop) => (event) => {
    let value = event.target.value
    let updatedDetails = { ...addressDetails, [prop]: value }
    if (prop === "countryCode" && event.target.value !== "") {
      updatedDetails = { ...updatedDetails, ...blankAddressDetails }
    } 

    setAddressDetails({ ...addressDetails, ...updatedDetails });
    updateAddressDetails({ ...addressDetails, ...updatedDetails });
  }

  return (
    <Fragment>
      <Grid container spacing={1}>
        <Grid item sm={12} xs={12}>
          <TextField
            id="firstName"
            label="First Name"
            helperText={errors.firstName?.length > 0 ? errors.firstName : ""}
            variant="outlined"
            fullWidth
            value={addressDetails.firstName}
            onChange={handleChange("firstName")}
            className={classes.formControl}
            color="secondary"
            inputProps={{
              maxLength: 50,
            }}
            onInput={(e) => {
              e.target.value = e.target.value.match(/[a-zA-Z-'\s]+/); //only accept letters (inclusive of spaces and hyphens and apostrophe for odd names)
            }}
          />
        </Grid>
        <Grid item sm={12} xs={12}>
          <TextField
            id="lastName"
            label="Last Name"
            variant="outlined"
            fullWidth
            value={addressDetails.lastName}
            onChange={handleChange("lastName")}
            className={classes.formControl}
            color="secondary"
            inputProps={{
              maxLength: 50,
            }}
            onInput={(e) => {
              e.target.value = e.target.value.match(/[a-zA-Z-'\s]+/); //only accept letters (inclusive of spaces and hyphens and apostrophe for odd names)
            }}
          />
        </Grid>
        <Grid item sm={12} xs={12}>
          <SelectCountry
            error={errors.countryCode}
            handleChange={handleChange}
            label = "Country"
            value={addressDetails.countryCode}
            countries={countries}
          />
        </Grid>
        <Grid item sm={6} xs={12}>
          <TextField
            id="line1"
            label="Address Line 1"
            variant="outlined"
            fullWidth
            value={addressDetails.line1}
            onChange={handleChange("line1")}
            className={classes.formControl}
            color="secondary"
            ref={ref}
            inputProps={{
              maxLength: 50,
            }}
          />
        </Grid>
        <Grid item sm={6} xs={12}>
          <TextField
            id="line2"
            label="Address Line 2"
            variant="outlined"
            fullWidth
            value={addressDetails.line2}
            onChange={handleChange("line2")}
            className={classes.formControl}
            color="secondary"
            inputProps={{
              maxLength: 50,
            }}
          />
        </Grid>
        {addressDetails.countryCode === "840" &&
          <Grid item sm={6} xs={12}>
            <SelectState
              error={errors.state}
              handleChange={handleChange}
              value={addressDetails.state}
              countryCode={addressDetails.countryCode}
            />
          </Grid>}
        <Grid item sm={6} xs={12}>
          <TextField
            value={addressDetails.city}
            id="city"
            label="City"
            variant="outlined"
            fullWidth
            onChange={handleChange("city")}
            className={classes.formControl}
            color="secondary"
            inputProps={{
              maxLength: 50,
            }}
            onInput={(e) => {
              e.target.value = e.target.value.match(/[a-zA-Z-.'\s]+/); //only accept letters (inclusive of spaces and hyphens and apostrophe for odd names)
            }}
          />
        </Grid>
        <Grid item sm={6} xs={12}>
          <TextField
            id="postalCode"
            label="Postal Code"
            variant="outlined"
            fullWidth
            value={addressDetails.postalCode}
            onChange={handleChange("postalCode")}
            className={classes.formControl}
            color="secondary"
            onInput={(e) => {
              e.target.value = e.target.value.match(/[0-9a-zA-Z]+/); //only accept letters and numbers 
            }}
          />
        </Grid>
        <Grid item sm={6} xs={12}>
          <TextField
            id="emailAddress"
            label="Email"
            helperText={errors.email.length > 0 ? errors.email : ""}
            variant="outlined"
            fullWidth
            value={addressDetails.emailAddress}
            onChange={handleChange("emailAddress")}
            className={classes.formControl}
            error={errors.email.length > 0}
            type="email"
            color="secondary"
          />
        </Grid>
        <Grid item sm={6} xs={12}>
          <PhoneNumber
            handleChange={handleChange}
            value={addressDetails.phoneNumber}
          />
        </Grid>
      </Grid>
    </Fragment>
  );
}

const mapStateToProps = (state) => ({
  addressDetailsState: state.billpay.addressDetails,
  errors: state.billpay.errors,
});

const mapDispatch = { setAddressDetails };

export default connect(
  mapStateToProps,
  mapDispatch
)(AddressForm);